import { api } from './api';
import { API_ENDPOINTS } from './api/config';

export interface ParameterType {
  id: string;
  name: string;
  description: string | null;
  created_at: string;
  updated_at: string | null;
}

export interface CreateParameterType {
  name: string;
  description?: string;
}

export interface UpdateParameterType {
  name?: string;
  description?: string;
}

const parameterTypeService = {
  getAll: async (): Promise<ParameterType[]> => {
    const response = await api.get(API_ENDPOINTS.PARAMETER_TYPES.BASE);
    return response.data;
  },

  getById: async (id: string): Promise<ParameterType> => {
    const response = await api.get(API_ENDPOINTS.PARAMETER_TYPES.BY_ID(id));
    return response.data;
  },

  create: async (parameterType: CreateParameterType): Promise<ParameterType> => {
    const response = await api.post(API_ENDPOINTS.PARAMETER_TYPES.BASE, parameterType);
    return response.data;
  },

  update: async (id: string, parameterType: UpdateParameterType): Promise<ParameterType> => {
    const response = await api.put(API_ENDPOINTS.PARAMETER_TYPES.BY_ID(id), parameterType);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(API_ENDPOINTS.PARAMETER_TYPES.BY_ID(id));
  },
};

export default parameterTypeService;
